import React, { FC, ReactNode } from "react";
import { Box, Drawer, DrawerProps, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const StyledDrawer: FC<
  DrawerProps & {
    onClose: () => void;
    width?: string;
    slots?: {
      topRight?: ReactNode;
    };
  }
> = ({ onClose, children, width, slots, ...props }) => {
  return (
    <Drawer
      anchor="right"
      {...props}
      onClose={onClose}
      elevation={0}
      PaperProps={{ variant: "outlined", sx: { maxWidth: "100vw", width, top: "64px", bottom: "auto", height: ["calc(100dvh - 64px)", "-webkit-calc(100dvh - 64px)", "-moz-calc(100dvh - 64px)"]} }}
      ModalProps={{
        slotProps: { backdrop: { sx: { backgroundColor: "transparent" } } },
      }}
    >

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        padding="16px"
      >
        <IconButton onClick={onClose} sx={{ color: "#171A1FFF" }}>
          <CloseIcon />
        </IconButton>
        {slots?.topRight || <></>}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "0 32px 24px",
          flex: "1",
          boxSizing: "border-box",
        }}
      >
        {children}
      </Box>
    </Drawer>
  );
};

export default StyledDrawer;
